import React from "react";
import {Form} from "../XLibItems";
import {XInputDecimal} from "@michalrakus/x-react-web-lib/XInputDecimal";
import {XInputText} from "@michalrakus/x-react-web-lib/XInputText";
import {XFormFooter} from "@michalrakus/x-react-web-lib/XFormFooter";
import {OperationType, XUtils} from "@michalrakus/x-react-web-lib/XUtils";
import {XInputDate} from "@michalrakus/x-react-web-lib/XInputDate";
import {XFormBaseModif} from "@michalrakus/x-react-web-lib/XFormBaseModif";
import {XFieldChangeEvent, XTableFieldChangeEvent} from "@michalrakus/x-react-web-lib/lib/components/XFieldChangeEvent";
import {XObject} from "@michalrakus/x-react-web-lib/lib/components/XObject";
import {XCustomFilter} from "@michalrakus/x-react-web-lib/lib/serverApi/FindParam";
import {Utils} from "../Utils";
import {XDropdown} from "@michalrakus/x-react-web-lib/XDropdown";
import {TypBudgetLineEnum} from "../common/enums";
import {XErrors} from "@michalrakus/x-react-web-lib/XErrors";
import {XFormAutoCompleteColumn, XFormColumn, XFormDataTable2} from "@michalrakus/x-react-web-lib/XFormDataTable2";
import {
    dateAsDB,
    dateFromModel,
    numberFromModel
} from "@michalrakus/x-react-web-lib/XUtilsConversions";
import {UtilsCommon} from "../common/UtilsCommon";
import {BudgetLineBrowse} from "./BudgetLineBrowse";
import {XCheckbox} from "@michalrakus/x-react-web-lib/XCheckbox";
import {TypBudgetLine} from "../model/typ-budget-line.entity";
import {BudgetLine} from "../model/budget-line.entity";
import {XUtilsCommon} from "@michalrakus/x-react-web-lib/XUtilsCommon";
import {BudgetLinePobocka} from "../model/budget-line-pobocka.entity";
import * as _ from "lodash";
import {XFormBase} from "@michalrakus/x-react-web-lib/XFormBase";
import type {XFormProps} from "@michalrakus/x-react-web-lib/XFormBase";
import {XAutoComplete} from "@michalrakus/x-react-web-lib/XAutoComplete";
import {XFormHeader} from "@michalrakus/x-react-web-lib/XFormHeader";

@Form("BudgetLine")
export class BudgetLineForm extends XFormBaseModif {

    private kodFromEditStart: string | null = null;
    private budgetFromEditStart: number | null = null;

    constructor(props: XFormProps) {
        super(props);

        // aby sme mali aj childList k dispozicii, pouzivame ho pri validacii
        // (nepouzivame frameworkovy save, preto sa childList neuklada do DB, ani nemame cascade na @OneToMany asociacii)
        this.addField("childList.id");

        this.onChangeKodZaznamuParent = this.onChangeKodZaznamuParent.bind(this);
        this.parentFilter = this.parentFilter.bind(this);
        this.onChangeTypBudgetLine = this.onChangeTypBudgetLine.bind(this);
        this.onClickAddRowBudgetLinePobocka = this.onClickAddRowBudgetLinePobocka.bind(this);
        this.onClickRemoveRowBudgetLinePobocka = this.onClickRemoveRowBudgetLinePobocka.bind(this);
    }

    preInitForm(budgetLine: BudgetLine, operationType: OperationType.Insert | OperationType.Update) {
        // ulozime si hodnotu fieldu kod zo zaciatku editacie (user moze hodnotu fieldu kod zmenit)
        this.kodFromEditStart = budgetLine.kod;
        this.budgetFromEditStart = budgetLine.budget;

        // doplnime mesiacOd/mesiacDo z projektu (ak zmenitObdobieZProjektu = false)
        // pri save mesiacOd/mesiacDo vymazeme
        for (const budgetLinePobocka of budgetLine.budgetLinePobockaList) {
            if (!budgetLinePobocka.zmenitObdobieZProjektu) {
                budgetLinePobocka.mesiacOd = budgetLine.projekt.mesiacOd;
                budgetLinePobocka.mesiacDo = budgetLine.projekt.mesiacDo;
            }
        }

        // sortujeme tu lebo ak pouzijeme prop sortField na tabulke, tak sortuje v priebehu editacie, co je neprijemne
        budgetLine.budgetLinePobockaList = XUtilsCommon.arraySort(budgetLine.budgetLinePobockaList, (budgetLinePobocka: BudgetLinePobocka) => `${budgetLinePobocka.pobocka.nazov}-${dateAsDB(dateFromModel(budgetLinePobocka.mesiacOd))}`);
    }

    onChangeKodZaznamuParent(e: XFieldChangeEvent) {
        let kod: string = '';
        if (e.object.parent) {
            kod += e.object.parent.kod + '.';
        }
        if (e.object.kodZaznamu) {
            kod += e.object.kodZaznamu;
        }
        e.object.kod = kod;
    }

    parentFilter(object: XObject): XCustomFilter | undefined {
        let filter: XCustomFilter = Utils.filterCurrentProjekt();
        // ak nie je insert noveho zaznamu (mame this.kodFromEditStart), vyfiltrujeme vsetky child zaznamy (vcetne seba), aby nam zo stromu nevznikol cyklicky graf
        if (this.kodFromEditStart) {
            filter = XUtilsCommon.filterAnd(filter, {where: "[kod] NOT LIKE :kod", params: {"kod": `${this.kodFromEditStart}%`}})!;
        }
        return filter;
    }

    onChangeZmenitObdobieZProjektu(e: XFieldChangeEvent) {
        if (e.object.zmenitObdobieZProjektu) {
            // predplnime z projektu
            e.object.mesiacOd = e.object.projekt.mesiacOd;
            e.object.mesiacDo = e.object.projekt.mesiacDo;
        }
        else {
            // vymazeme (pre budget line sa pouzije obdobie z projektu)
            e.object.mesiacOd = null;
            e.object.mesiacDo = null;
        }
    }

    async onChangeTypBudgetLine(e: XFieldChangeEvent) {
        // ak user zmenil typ suctovy na koncovy, zmenil budget a vratil typ na suctovy, tak vratime povodnu (vypocitanu) hodnotu
        if (e.object.typBudgetLine && e.object.typBudgetLine.code === TypBudgetLineEnum.Suctovy) {
            e.object.budget = this.budgetFromEditStart;
        }

        if (e.object.typBudgetLine && e.object.typBudgetLine.code === TypBudgetLineEnum.KoncovyPobocky) {
            e.object.budget = 0.0;
            const pobockaList: any[] = await XUtils.fetchRows('Pobocka', Utils.filterCurrentOrganizacia(), 'nazov');
            e.object.budgetLinePobockaList = [];
            for (const pobocka of pobockaList) {
                const budgetLinePobocka: BudgetLinePobocka = {pobocka: pobocka, zmenitObdobieZProjektu: false, budget: 0.0} as any as BudgetLinePobocka;
                BudgetLineForm.pobockaPredplnMesiacOdMesiacDo(budgetLinePobocka, e.object as BudgetLine);
                this.onTableAddRow("budgetLinePobockaList", budgetLinePobocka, "id");
            }
        }
        else {
            // treba vyprazdnit budgetLinePobockaList, ak nie je prazdny
            if (e.object.budgetLinePobockaList.length > 0) {
                e.object.budgetLinePobockaList = [];
            }
        }

        // zrusime obdobie na budgete, ak bolo zadane (len TypBudgetLineEnum.KoncovySpolocny ma povolene obdobie)
        if (e.object.typBudgetLine && e.object.typBudgetLine.code !== TypBudgetLineEnum.KoncovySpolocny) {
            e.object.zmenitObdobieZProjektu = false;
            e.object.mesiacOd = null;
            e.object.mesiacDo = null;
        }
    }

    readOnlyPobockaMesiacOdMesiacDo(object: BudgetLine, tableRow: BudgetLinePobocka): boolean {
        return !tableRow.zmenitObdobieZProjektu;
    }

    onChangePobockaZmenitObdobieZProjektu(e: XTableFieldChangeEvent) {
        BudgetLineForm.pobockaPredplnMesiacOdMesiacDo(e.tableRow, e.object as BudgetLine);
    }

    onChangePobockaBudget(e: XTableFieldChangeEvent) {
        // let pobockaBudgetSpolu: number = 0;
        // for (const budgetLinePobocka of e.object.budgetLinePobockaList) {
        //     let pobockaBudget: number | null;
        //     if (budgetLinePobocka.id !== e.tableRow.id) {
        //         pobockaBudget = numberFromModel(budgetLinePobocka.budget);
        //     }
        //     else {
        //         pobockaBudget = numberFromModel(e.tableRow.budget); // tu netreba numberFromModel (suma bola prave zapisana uzivatelom), ale pre istotu...
        //     }
        //     if (pobockaBudget) {
        //         pobockaBudgetSpolu += pobockaBudget;
        //     }
        // }
        // e.object.budget = UtilsCommon.numberRound(pobockaBudgetSpolu); // pre istotu zaokruhlime, sumovanim niekedy vznika chyba

        e.object.budget = BudgetLineForm.computePobockaBudgetSpolu(e.object as BudgetLine);
    }

    readOnlyBudget(object: XObject): boolean {
        let readOnly: boolean = true;
        // len pri type koncovy-spolocny mozme zapisat budget, pri suctovom a koncovom pobockovom sa budget vypocitava = sucet child zaznamov
        if (object.typBudgetLine && object.typBudgetLine.code === TypBudgetLineEnum.KoncovySpolocny) {
            readOnly = false;
        }
        return readOnly;
    }

    onClickAddRowBudgetLinePobocka() {
        const budgetLinePobocka: BudgetLinePobocka = {zmenitObdobieZProjektu: false} as any as BudgetLinePobocka;
        BudgetLineForm.pobockaPredplnMesiacOdMesiacDo(budgetLinePobocka, this.state.object);
        this.onTableAddRow("budgetLinePobockaList", budgetLinePobocka);
    };

    onClickRemoveRowBudgetLinePobocka(budgetLinePobocka: BudgetLinePobocka) {
        // default remove
        this.onTableRemoveRow("budgetLinePobockaList", budgetLinePobocka);
        // preratame celkovy budget
        this.state.object.budget = BudgetLineForm.computePobockaBudgetSpolu(this.state.object);
    }

    static pobockaPredplnMesiacOdMesiacDo(budgetLinePobocka: BudgetLinePobocka, budgetLine: BudgetLine) {
        if (!budgetLinePobocka.zmenitObdobieZProjektu) {
            // predplnime z projektu
            budgetLinePobocka.mesiacOd = budgetLine.projekt.mesiacOd;
            budgetLinePobocka.mesiacDo = budgetLine.projekt.mesiacDo;
        }
    }

    static computePobockaBudgetSpolu(budgetLine: BudgetLine): number {
        let pobockaBudgetSpolu: number = 0;
        for (const budgetLinePobocka of budgetLine.budgetLinePobockaList) {
            pobockaBudgetSpolu += numberFromModel(budgetLinePobocka.budget) ?? 0;
        }
        return UtilsCommon.numberRound(pobockaBudgetSpolu)!; // pre istotu zaokruhlime, sumovanim niekedy vznika chyba
    }

    // overrides method in XFormBase
    async validate(budgetLine: BudgetLine): Promise<XErrors> {
        const errors: XErrors = {};

        if (budgetLine.zmenitObdobieZProjektu) {
            if (budgetLine.mesiacOd === null) {
                errors.mesiacOd = "Mesiac od musí byť vyplnený.";
            }
            if (budgetLine.mesiacDo === null) {
                errors.mesiacDo = "Mesiac do musí byť vyplnený.";
            }
        }

        for (const budgetLinePobocka of budgetLine.budgetLinePobockaList) {
            if (budgetLinePobocka.zmenitObdobieZProjektu) {
                if (budgetLinePobocka.mesiacOd === null) {
                    //zapiseme chybu do zaznamu budgetLinePobocka do specialneho technickeho atributu
                    XFormBase.saveErrorsIntoXRowTechData(budgetLinePobocka, {mesiacOd: `Mesiac od musí byť vyplnený.`});
                }
                if (budgetLinePobocka.mesiacDo === null) {
                    //zapiseme chybu do zaznamu budgetLinePobocka do specialneho technickeho atributu
                    XFormBase.saveErrorsIntoXRowTechData(budgetLinePobocka, {mesiacDo: `Mesiac do musí byť vyplnený.`});
                }
                if (budgetLinePobocka.mesiacOd && budgetLinePobocka.mesiacDo
                    && !(dateFromModel(budgetLinePobocka.mesiacOd)! <= dateFromModel(budgetLinePobocka.mesiacDo)!)) {
                    //zapiseme chybu do zaznamu budgetLinePobocka do specialneho technickeho atributu
                    XFormBase.saveErrorsIntoXRowTechData(budgetLinePobocka, {mesiacDo: `Mesiac do musí byť väčší alebo rovný ako mesiac od.`});
                }
            }
        }

        // kontrola aby sa budgety pre pobocky casovo neprekryvali
        for (let i: number = 0; i < budgetLine.budgetLinePobockaList.length; i++) {
            const budgetLinePobocka1: BudgetLinePobocka = budgetLine.budgetLinePobockaList[i];
            for (let j: number = i + 1; j < budgetLine.budgetLinePobockaList.length; j++) {
                const budgetLinePobocka2: BudgetLinePobocka = budgetLine.budgetLinePobockaList[j];
                if (budgetLinePobocka1.pobocka && budgetLinePobocka2.pobocka && budgetLinePobocka1.pobocka.id === budgetLinePobocka2.pobocka.id
                    && budgetLinePobocka1.mesiacOd && budgetLinePobocka1.mesiacDo && budgetLinePobocka2.mesiacOd && budgetLinePobocka2.mesiacDo
                    && XUtilsCommon.dateIntersect(
                            dateFromModel(budgetLinePobocka1.mesiacOd)!, dateFromModel(budgetLinePobocka1.mesiacDo)!,
                            dateFromModel(budgetLinePobocka2.mesiacOd)!, dateFromModel(budgetLinePobocka2.mesiacDo)!)) {
                    errors.budgetLinePobockaList = `Obdobia pre pobočku ${budgetLinePobocka1.pobocka.nazov} sa prekrývajú.`;
                    break;
                }
            }
        }

        // koncovy budget line mozme zadat len ak zaznam nema ziadne child zaznamy
        if (budgetLine.typBudgetLine
            && (budgetLine.typBudgetLine.code === TypBudgetLineEnum.KoncovySpolocny || budgetLine.typBudgetLine.code === TypBudgetLineEnum.KoncovyPobocky)
            && budgetLine.childList && budgetLine.childList.length > 0) {

            errors.typBudgetLine = `Typ "koncový" môže byť použitý len na zázname, ktorý nemá podzáznamy (nie je rodič pre iné záznamy).`;
        }
        return errors;
    }

    preSave(object: XObject) {
        super.preSave(object);

        // na suctovom zazname je budget readOnly a treba mu zapisat nejaku hodnotu
        if (object.typBudgetLine && object.typBudgetLine.code === TypBudgetLineEnum.Suctovy && !object.budget) {
            object.budget = 0;
        }
    }

    async saveRow(): Promise<any> {
        // vymazeme pripadne mesiacOd/mesiacDo na pobockach, robime to na klonovanych datach, lebo mame validaciu na backende
        const budgetLineCopy = _.cloneDeep(this.state.object);
        for (const budgetLinePobocka of budgetLineCopy.budgetLinePobockaList) {
            if (!budgetLinePobocka.zmenitObdobieZProjektu) {
                budgetLinePobocka.mesiacOd = null;
                budgetLinePobocka.mesiacDo = null;
            }
        }
        return XUtils.fetch('save-budget-line', budgetLineCopy);
    }

    render() {
        const obdobieElemList: JSX.Element[] = [];
        if (this.state.object) {
            // len pre typ KoncovySpolocny tu zobrazime obdobie
            // pre typ KoncovyPobocky bude obdobie zobrazene/zapisane v tabulke pobockovych budgetov
            const typBudgetLine: TypBudgetLine = this.state.object.typBudgetLine;
            if (typBudgetLine && typBudgetLine.code === TypBudgetLineEnum.KoncovySpolocny) {
                obdobieElemList.push(<XCheckbox form={this} field="zmenitObdobieZProjektu" label="Zmeniť obdobie z projektu"
                                                labelStyle={{width: '18rem'}} onChange={this.onChangeZmenitObdobieZProjektu}/>);
                if (this.state.object.zmenitObdobieZProjektu) {
                    obdobieElemList.push(<XInputDate form={this} field="mesiacOd" label="Mesiac od"/>);
                    obdobieElemList.push(<XInputDate form={this} field="mesiacDo" label="Mesiac do"/>);
                }
                else {
                    // zobrazime obdobie z projektu (defaultne readOnly)
                    obdobieElemList.push(<XInputDate form={this} field="projekt.mesiacOd" label="Mesiac od"/>);
                    obdobieElemList.push(<XInputDate form={this} field="projekt.mesiacDo" label="Mesiac do"/>);
                }
            }
        }

        return (
            <div>
                <XFormHeader form={this} label="Budget line"/>
                <div className="x-form-row">
                    <div className="x-form-col">
                        <XInputDecimal form={this} field="id" label="ID" readOnly={true}/>
                        <XInputDate form={this} field="modifDate" label="Dátum modif." readOnly={true}/>
                        <XInputText form={this} field="modifXUser.name" label="Modifikoval" size={20}/>
                        <XInputText form={this} field="projekt.nazov" label="Projekt" size={30}/>
                        <XAutoComplete form={this} assocField="parent" displayField="kodNazov" label="Rodič" width="27rem"
                                       searchBrowse={<BudgetLineBrowse/>}
                                       onChange={this.onChangeKodZaznamuParent} filter={this.parentFilter}/>
                        <XInputText form={this} field="kod" label="Kód" size={10} readOnly={true}/>
                        <XInputText form={this} field="kodZaznamu" label="Kód záznamu" size={5} onChange={this.onChangeKodZaznamuParent}/>
                        <XInputText form={this} field="nazov" label="Názov" inputStyle={{width:'27rem'}}/>
                    </div>
                    <div className="x-form-col">
                        <XDropdown form={this} assocField="typBudgetLine" displayField="name" sortField="id" label="Typ" onChange={this.onChangeTypBudgetLine}/>
                        {obdobieElemList}
                        <XInputDecimal form={this} field="budget" label="Budget" size={8} readOnly={this.readOnlyBudget}/>
                        {/* table is sorted by (pobocka.nazov, mesiacOd) in method this.preInitForm, default sort by id is turned off (sortField="none") */}
                        <XFormDataTable2 form={this} assocField="budgetLinePobockaList" label="Pobočky - budget" sortField="none"
                                         showAddRemoveButtons={this.state.object?.typBudgetLine?.code === TypBudgetLineEnum.KoncovyPobocky}
                                         onClickAddRow={this.onClickAddRowBudgetLinePobocka} onClickRemoveRow={this.onClickRemoveRowBudgetLinePobocka}>
                            <XFormAutoCompleteColumn assocField="pobocka" displayField="nazov" header="Pobočka" width="12rem" filter={Utils.filterCurrentOrganizacia()}/>
                            <XFormColumn field="zmenitObdobieZProjektu" header="Zmeniť obdobie" width="10rem" onChange={this.onChangePobockaZmenitObdobieZProjektu}/>
                            <XFormColumn field="mesiacOd" header="Mesiac od" readOnly={this.readOnlyPobockaMesiacOdMesiacDo}/>
                            <XFormColumn field="mesiacDo" header="Mesiac do" readOnly={this.readOnlyPobockaMesiacOdMesiacDo}/>
                            <XFormColumn field="budget" header="Budget" width="7rem" onChange={this.onChangePobockaBudget}/>
                        </XFormDataTable2>
                    </div>
                </div>
                <XFormFooter form={this}/>
            </div>
        );
    }
}

XUtils.registerAppForm(<BudgetLineForm/>, "BudgetLine");
